import { render, staticRenderFns } from "./aiRobotKnowledge.vue?vue&type=template&id=cde20d6c"
import script from "./aiRobotKnowledge.vue?vue&type=script&lang=js"
export * from "./aiRobotKnowledge.vue?vue&type=script&lang=js"
import style0 from "./aiRobotKnowledge.vue?vue&type=style&index=0&id=cde20d6c&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports